import { useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Menu from "./components/Menu";
import Testimonials from "./components/Testimonials";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import BookingPopup from "./components/BookingPopup";
import MenuSelection from "./pages/MenuSelection";

// Home sections as a component so we can route cleanly
function Home({ onBookNow }) {
    return (
        <>
            <Hero onBookNow={onBookNow} />
            <About />
            <Services />
            <Menu />
            <Testimonials />
            <Gallery />
            <Contact />
        </>
    );
}

function AppShell() {
    const [showPopup, setShowPopup] = useState(false);
    const navigate = useNavigate();

    const handleNext = (data) => {
        if (data === "open") {
            setShowPopup(true);
        } else {
            // data = { occasion, service }
            localStorage.setItem("bookingBasics", JSON.stringify(data));
            setShowPopup(false);
            navigate("/menu"); // 👉 go to the selection page
        }
    };

    const openPopup = () => setShowPopup(true);

    return (
        <div className="relative bg-white text-[#1F2937] font-serif min-h-screen">
            <Navbar onBookNow={openPopup} />

            <Routes>
                <Route path="/" element={<Home onBookNow={openPopup} />} />
                <Route path="/menu" element={<MenuSelection />} />
            </Routes>

            <BookingPopup
                isOpen={showPopup}
                onClose={() => setShowPopup(false)}
                onNext={handleNext}
            />
        </div>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AppShell />
        </BrowserRouter>
    );
}
